import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { totalBonuses, totalVolumes } from '../data/offer';
export function GuaranteeSection() {
  return <section className="bg-navy-950 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-98" data-mp="9ttgc9z21wy4">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-99" data-mp="et67v80vfs71">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border-2 border-silver-400/30 bg-navy-800 p-8 shadow-lg shadow-black/30 sm:p-12" data-id="element-100" data-mp="euqwyi4f2ixi">
          <span className="metal inline-flex rounded-full p-4 text-navy-950" data-id="element-101" data-mp="xjntksnadniw">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-102" data-mp="xlrv53xpqag0" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-white" data-id="element-103" data-mp="12gxhu4yxvt55">
            Complete 7-day guarantee
          </h2>
          <p className="mt-4 leading-relaxed text-silver-300" data-id="element-104" data-mp="25sgi1ehe880v">
            Open all {totalVolumes} volumes. Review all {totalBonuses} bonuses. Use them in your most challenging forensic
            science class this week. If you feel your students didn't respond better or the materials didn't save you
            hours of work:
          </p>
          <p className="mt-6 rounded-lg border border-silver-400/20 bg-navy-900 px-5 py-4 text-lg font-extrabold text-white" data-id="element-105" data-mp="1rtyx1oivh9mn">
            We refund 100% of your money. No questions. No forms. No complications.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-silver-300" data-id="element-106" data-mp="2jlo9n65h53ik">
            Because if this teacher ready doesn't deliver the value we promise, we don't want to keep your money.
          </p>
        </motion.div>
      </div>
    </section>;
}